import { Res, Permission, TicketDTO, PaymentDTO, SaleDTO } from 'core/api';

import { CustomError, Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { getDivisionMode } from './getDivisionMode';
import { splitTicketPayments } from './splitTicketPayments';
import { splitTicketLinesAuto, splitTicketLinesManual } from './splitTicketLines';
import { ThemeManager } from 'pos/ui';
import { blockTicketWhileClosing } from '../helpers/document-creation';
import { Message } from 'core/ui-next/modal';


type SplitTicketParams = {
	ticket: TicketDTO,
	addPayments: (payments: PaymentDTO[], prepayAmount: number) => Promise<Result<SaleDTO, CustomError>>
}

declare global {
	interface CommandType {
		splitTicket: (params: SplitTicketParams) => Promise<Result>
	}
}

Command.register('splitTicket', Preconditions.ensure(Permission.Ticket_Close), async ({ ticket, addPayments }: SplitTicketParams): Promise<Result> => {

	return blockTicketWhileClosing(ticket.Id, async () => {

		if (ticket.IsEmpty) {
			await Message.show(Res.Msg.MSG_TICKET_IS_EMPTY());
			return Result.error();
		}

		if (ticket.Lines.some(x => x.TotalAmount < 0)) {
			await Message.show(Res.Msg.MSG_CANNOT_SPLIT_TICKET_WITH_NEGATIVE_LINES());
			return Result.error();
		}


		if (!ThemeManager.isWebPos())
			return await splitTicketLinesManual(ticket);

		const divisionModeResult = await getDivisionMode(ticket.PendingAmount, ticket.TableCompanions);
		if (!divisionModeResult.ok)
			return Result.error();

		const mode = divisionModeResult.value;
		if (mode.type === 'SplitPayment')
			return await splitTicketPayments({ ticket, parts: mode.parts, addPayments });

		if (mode.type === 'SplitAuto')
			return await splitTicketLinesAuto(ticket, mode.parts);

		return await splitTicketLinesManual(ticket);
	});
});